export default {
  CLICK_TO_FILL: `You have a daily questionnaire to fill, please click here to do so.`,
  CLICK_TO_REFILL: `You filled the questionnaire and were shown an warning message. Click here to change your responses.`,
  FILLED_CLICK_TO_FILL_AGAIN: `You have filled the questionnaire. Click here to fill it again.`,
  QUESTIONNAIRE_MODAL: {
    TITLE: `Daily questionnaire`,
    SUMMARY: ``,
    ANSWER_ALL_QUESTIONS: `Please answer all questions.`,
    ERROR_TRIGGERED: `Based on your answers to the questionnaire, you must contact your manager and await further instructions.`,
    HAS_ERROR: `An unknown error occurred, please try again.`,
    THANK_YOU: `Thank you for filling out the questionnaire!`,
    EXPLANATION_WARNING: `You previously answered these questions in a way that caused a warning.`,
    EXPLANATION: {
      LABEL: `Explanation`,
      PLACEHOLDER: `Indicate why you are re-submitting the questionnaire and changing your answers.`,
      DESCRIPTION: ``
    }
  }
}
